import "./di/register";
import { isDevProfileSwitcherEnabled } from "configs/DevAuth";
import Routing, { router } from "./Routing";
import { lazy, Suspense, useSyncExternalStore } from "react";
import ModuleConfig from "configs/ModuleConfig";
import { container } from "tsyringe";
import { UserProvider } from "contexts/User";
import { InvestorPortalAccessProvider } from "contexts/InvestorPortalAccess";
import { AuthProvider } from "contexts/Auth";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import SignatureAlertBanner from "components/materials/SignatureAlertBanner";
import useSealBanner from "hooks/useSealBanner";
import HasRules from "components/materials/HasRules";

// Webpack removes this import entirely from production builds.
const DevProfileSwitcher = process.env.NODE_ENV === "development" ? lazy(() => import("components/materials/DevProfileSwitcher")) : () => null;

export default function App() {
	return (
		<div>
			<AuthProvider>
				<UserProvider>
					<InvestorPortalAccessProvider>
						<AppContainer />
					</InvestorPortalAccessProvider>
				</UserProvider>
			</AuthProvider>
			<ToastContainer />
		</div>
	);
}

function AppContainer() {
	const pathname = useSyncExternalStore(router.subscribe, () => router.state.location.pathname);
	const isProfilePage = isDevProfileSwitcherEnabled && pathname === container.resolve(ModuleConfig).get().modules.pages.Login.props.path;
	const { isOpen, onSealSubmited, close, userHasSignature } = useSealBanner();
	return (
		<>
			{!isProfilePage && (
				<HasRules requiredRules={{ AND: { access_platform__cgp: true } }}>
					<SignatureAlertBanner isOpen={isOpen} close={close} onSealSubmited={onSealSubmited} userHasSignature={userHasSignature} />
				</HasRules>
			)}
			<Routing />
			{isDevProfileSwitcherEnabled && !isProfilePage && (
				<Suspense fallback={null}>
					<DevProfileSwitcher />
				</Suspense>
			)}
		</>
	);
}
